<template>
  <!-- Need to add height inherit because Vue 2 don't support multiple root ele -->
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ 'show': shallShowUserProfileSidebar || shallShowActiveChatContactSidebar || mqShallShowLeftSidebar }"
      @click="mqShallShowLeftSidebar = shallShowActiveChatContactSidebar = shallShowUserProfileSidebar = false"
    />

    <!-- Main Area -->
    <section class="chat-app-window">
      Chat message from pusher: {{ messages }}
      <!-- Start Chat Logo -->
      <div
        v-if="!activeChat.contact"
        class="start-chat-area"
      >
        <div class="mb-1 start-chat-icon">
          <feather-icon
            icon="MessageSquareIcon"
            size="56"
          />
        </div>
        <h4
          class="sidebar-toggle start-chat-text"
          @click="startConversation"
        >
          Start Conversation
        </h4>
      </div>

      <!-- Chat Content -->
      <div
        v-else
        class="active-chat"
      >
        <!-- Chat Navbar -->
        <div class="chat-navbar">
          <header class="chat-header">

            <!-- Avatar & Name -->
            <div class="d-flex align-items-center">

              <!-- Toggle Icon -->
              <div class="sidebar-toggle d-block d-lg-none mr-1">
                <feather-icon
                  icon="MenuIcon"
                  class="cursor-pointer"
                  size="21"
                  @click="mqShallShowLeftSidebar = true"
                />
              </div>

              <b-avatar
                size="36"
                :src="activeChat.contact.avatar"
                class="mr-1 cursor-pointer badge-minimal"
                badge
                :badge-variant="resolveAvatarBadgeVariant(activeChat.contact.status)"
                @click.native="shallShowActiveChatContactSidebar = true"
              />
              <h6 class="mb-0">
                {{ activeChat.contact.fullName }}
              </h6>
            </div>

            <!-- Contact Actions -->
            <div class="d-flex align-items-center">
              <feather-icon
                icon="PhoneCallIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-1"
              />
              <feather-icon
                icon="VideoIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-1"
              />
              <feather-icon
                icon="SearchIcon"
                size="17"
                class="cursor-pointer d-sm-block d-none mr-50"
              />
              <div class="dropdown">
                <b-dropdown
                  variant="link"
                  no-caret
                  toggle-class="p-0"
                  right
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="17"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item>
                    View Contact
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Mute Notifications
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Block Contact
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Clear Chat
                  </b-dropdown-item>
                  <b-dropdown-item>
                    Report
                  </b-dropdown-item>
                </b-dropdown>
              </div>
            </div>
          </header>
        </div>

        <!-- User Chat Area -->
        <vue-perfect-scrollbar
          ref="refChatLogPS"
          :settings="perfectScrollbarSettings"
          class="user-chats scroll-area"
        >
          <chat-log
            :chat-data="activeChat"
            :profile-user-avatar="profileUserData.avatar"
          />
        </vue-perfect-scrollbar>

        <!-- Message Input -->
        <b-form
          class="chat-app-form"
          @submit.prevent="sendMessage"
        >
          <b-input-group class="input-group-merge form-send-message mr-1">
            <b-form-input
              v-model="chatInputMessage"
              placeholder="Enter your message"
            />
          </b-input-group>
          <b-button
            variant="primary"
            type="submit"
          >
            Send
          </b-button>
        </b-form>
      </div>
    </section>

    <!-- Active Chat Contact Details Sidebar -->
    <chat-active-chat-content-details-sidedbar
      :shall-show-active-chat-contact-sidebar.sync="shallShowActiveChatContactSidebar"
      :contact="activeChat.contact || {}"
    />

    <!-- Sidebar -->
    <portal to="content-renderer-sidebar-left">
      <chat-left-sidebar
        :chats-contacts="chatsContacts"
        :contacts="contacts"
        :active-chat-contact-id="activeChat.contact ? activeChat.contact.id : null"
        :shall-show-user-profile-sidebar.sync="shallShowUserProfileSidebar"
        :profile-user-data="profileUserData"
        :profile-user-minimal-data="profileUserDataMinimal"
        :mq-shall-show-left-sidebar.sync="mqShallShowLeftSidebar"
        @show-user-profile="showUserProfileSidebar"
        @open-chat="openChatOfContact"
      />
    </portal>
  </div>
</template>

<script>
import store from '@/store'
import {
  ref, onUnmounted, nextTick,
} from '@vue/composition-api'
import {
  BAvatar, BDropdown, BDropdownItem, BForm, BInputGroup, BFormInput, BButton,
} from 'bootstrap-vue'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
// import { formatDate } from '@core/utils/filter'
import { $themeBreakpoints } from '@themeConfig'
import { useResponsiveAppLeftSidebarVisibility } from '@core/comp-functions/ui/app'
// import Pusher from 'pusher-js'
import useJwt from '@/auth/jwt/useJwt'
import SocketChat from '@/libs/socket.chat'
import ChatLeftSidebar from './ChatLeftSidebar.vue'
// import chatStoreModule from './chatStoreModule'
import ChatActiveChatContentDetailsSidedbar from './ChatActiveChatContentDetailsSidedbar.vue'
import ChatLog from './ChatLog.vue'
import useChat from './useChat'

export default {
  components: {

    // BSV
    BAvatar,
    BDropdown,
    BDropdownItem,
    BForm,
    BInputGroup,
    BFormInput,
    BButton,

    // 3rd Party
    VuePerfectScrollbar,

    // SFC
    ChatLeftSidebar,
    ChatActiveChatContentDetailsSidedbar,
    ChatLog,
  },
  setup() {
    const messages = ref([]);

    // Enable pusher logging - don't include this in production
    // Pusher.logToConsole = true;
    // const pusher = new Pusher('78a6e721faf27ebc2e95', {
    //   cluster: 'ap1',
    // });

    // const channel = pusher.subscribe('private-vovat-channel');
    // channel.bind('chat-message', (data) => {
    //   console.log('data', data);
    //   // messages.value.push(JSON.stringify(data));
    //   messages.value.push(data);
    // });
    // channel.trigger('client-chat-message', { message: 'Hello, world!' })

    const accessToken = useJwt.getToken();

    SocketChat.setupSocketConnection(accessToken)

    SocketChat.socket.on('connect', () => {
      console.log('Connected to server');
      const message = 'Helo from client';
      SocketChat.socket.emit('receive-message', message);
    });
    SocketChat.socket.on('broadcast-message', (message) => {
      console.log('broadcast-message listen message', message);
      messages.value = message
    });

    onUnmounted(() => {
      SocketChat.disconnect();
    })

    const { resolveAvatarBadgeVariant } = useChat()

    // Scroll to Bottom ChatLog
    const refChatLogPS = ref(null)
    const scrollToBottomInChatLog = () => {
      const scrollEl = refChatLogPS.value.$el || refChatLogPS.value
      scrollEl.scrollTop = scrollEl.scrollHeight
    }

    // ------------------------------------------------
    // Chats & Contacts
    // ------------------------------------------------
    const chatsContacts = ref([])
    const contacts = ref([])
    const perPage = ref(300);
    const totalEntries = ref(0);
    const currentPage = ref(1);
    const isPaginate = ref(1);
    const sortBy = ref('id');
    const isSortDirDesc = ref(true);

    const fetchChatAndContacts = () => {
      store.dispatch('users/fetchUsers', {
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        isPaginate: isPaginate.value,
      })
        .then(res => {
          console.log('res', res);
          if (res.status === 200) {
            if (res.data.code === 200) {
              const users = res.data.data.data;
              users.forEach(item => {
                chatsContacts.value.push({
                  id: item.id,
                  fullName: item.full_name,
                  role: item.role_names,
                  about: 'Vov news portal',
                  avatar: item.avatar,
                  status: 'offline',
                  chat: {
                    unseenMsgs: 0,
                  },
                });
              });
            }
          }
          contacts.value = chatsContacts.value;
        })
    }

    fetchChatAndContacts()

    // ------------------------------------------------
    // Single Chat
    // ------------------------------------------------
    const activeChat = ref({})
    const chatInputMessage = ref('')
    const openChatOfContact = userId => {
      // Reset send message input value
      chatInputMessage.value = ''

      store.dispatch('chat/getMessage', { userId })
        .then(res => {
          if (res.status === 200) {
            if (res.data.code === 200) {
              // console.log('getMessage userId', userId);
              // console.log('getMessage response', res.data.data);
              activeChat.value = res.data.data

              // Set unseenMsgs to 0
              const contact = chatsContacts.value.find(c => c.id === userId)
              // if (contact) contact.chat.unseenMsgs = 0
              activeChat.value.contact = contact;

              console.log('activeChat', activeChat.value);
              // Scroll to bottom
              nextTick(() => { scrollToBottomInChatLog() })
            }
          }
        })

      // if SM device =>  Close Chat & Contacts left sidebar
      // eslint-disable-next-line no-use-before-define
      mqShallShowLeftSidebar.value = false
    }
    const sendMessage = () => {
      if (!chatInputMessage.value) return
      const payload = {
        contactId: activeChat.value.contact.id,
        // eslint-disable-next-line no-use-before-define
        senderId: profileUserDataMinimal.value.id,
        message: chatInputMessage.value,
      }
      store.dispatch('chat/sendMessage', payload)
        .then(response => {
          console.log('sendMessage response', response);
          // const { newMessageData, chat } = response.data

          // // ? If it's not undefined => New chat is created (Contact is not in list of chats)
          // if (chat !== undefined) {
          //   activeChat.value = { chat, contact: activeChat.value.contact }
          //   chatsContacts.value.push({
          //     ...activeChat.value.contact,
          //     chat: {
          //       id: chat.id,
          //       lastMessage: newMessageData,
          //       unseenMsgs: 0,
          //     },
          //   })
          // } else {
          //   // Add message to log
          //   activeChat.value.chat.chat.push(newMessageData)
          // }

          // // Reset send message input value
          // chatInputMessage.value = ''

          // // Set Last Message for active contact
          // const contact = chatsContacts.value.find(c => c.id === activeChat.value.contact.id)
          // contact.chat.lastMessage = newMessageData

          // // Scroll to bottom
          // nextTick(() => { scrollToBottomInChatLog() })
        })
    }

    const perfectScrollbarSettings = {
      maxScrollbarLength: 150,
    }

    // User Profile Sidebar
    // ? Will contain all details of profile user (e.g. settings, about etc.)
    const profileUserData = ref({
      id: 11,
      avatar: '',
      fullName: 'John Doe',
      role: 'admin',
      about:
        'Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.',
      status: 'online',
      settings: {
        isTwoStepAuthVerificationEnabled: true,
        isNotificationsOn: false,
      },
    })
    // ? Will contain id, name and avatar & status
    const profileUserDataMinimal = ref({})

    const dataUser = useJwt.getUserLocal();

    profileUserDataMinimal.value = {
      id: dataUser.id,
      avatar: dataUser.avatar,
      fullName: dataUser.full_name,
      role: dataUser.role_names,
      about: '',
      status: 'online',
      settings: {
        isTwoStepAuthVerificationEnabled: true,
        isNotificationsOn: false,
      },
      chat: {
        unseenMsgs: 0,
      },
    }

    const shallShowUserProfileSidebar = ref(false)
    const showUserProfileSidebar = () => {
      shallShowUserProfileSidebar.value = true
      profileUserData.value = profileUserDataMinimal.value
      // store.dispatch('chat/getProfileUser', { id: dataUser.id })
      //   .then(response => {
      //     console.log('getProfileUser', response);
      //     profileUserData.value = response.data
      //     shallShowUserProfileSidebar.value = true
      //   })
    }

    // Active Chat Contact Details
    const shallShowActiveChatContactSidebar = ref(false)

    // UI + SM Devices
    // Left Sidebar Responsiveness
    const { mqShallShowLeftSidebar } = useResponsiveAppLeftSidebarVisibility()
    const startConversation = () => {
      if (store.state.app.windowWidth < $themeBreakpoints.lg) {
        mqShallShowLeftSidebar.value = true
      }
    }

    return {
      // Filters
      // formatDate,
      messages,
      // useChat
      resolveAvatarBadgeVariant,

      // Chat & Contacts
      chatsContacts,
      contacts,

      // Single Chat
      refChatLogPS,
      activeChat,
      chatInputMessage,
      openChatOfContact,
      sendMessage,

      // Profile User Minimal Data
      profileUserDataMinimal,

      // User Profile Sidebar
      profileUserData,
      shallShowUserProfileSidebar,
      showUserProfileSidebar,

      // Active Chat Contact Details
      shallShowActiveChatContactSidebar,

      // UI
      perfectScrollbarSettings,

      // UI + SM Devices
      startConversation,
      mqShallShowLeftSidebar,
    }
  },
}
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "~@core/scss/base/pages/app-chat.scss";
@import "~@core/scss/base/pages/app-chat-list.scss";
</style>
